var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0117C24.8366 32.0117 32 24.8483 32 16.0117C32 7.17516 24.8366 0.0117188 16 0.0117188C7.16344 0.0117188 0 7.17516 0 16.0117C0 24.8483 7.16344 32.0117 16 32.0117Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0117C24.8365 32.0117 32 24.8482 32 16.0117C32 14.0546 31.648 12.1798 31.0048 10.4465H0.995188C0.352063 12.1798 0 14.0546 0 16.0117C0 24.8482 7.1635 32.0117 16 32.0117Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0117C22.8794 32.0117 28.7441 27.6697 31.0048 21.5769H0.995178C3.25587 27.6697 9.12055 32.0117 16 32.0117Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1377 9.05518V17.0368C4.1377 21.5771 10.069 22.9682 10.069 22.9682C10.069 22.9682 16.0003 21.5771 16.0003 17.0368V9.05518H4.1377Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52832 9.05518V17.0368C5.52832 17.5698 5.6467 18.0732 5.8812 18.5451H14.2554C14.4899 18.0732 14.6083 17.5698 14.6083 17.0368V9.05518H5.52832Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8513 14.6204H10.7644V13.2291H12.1557V11.8378H10.7644V10.4465H9.37307V11.8378H7.98182V13.2291H9.37307V14.6204H7.28607V16.0117H9.37307V17.403H10.7644V16.0117H12.8513V14.6204Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77943 20.4875C8.67599 21.0509 9.59712 21.378 10.0687 21.5235C10.5402 21.3781 11.4614 21.0509 12.3579 20.4875C13.2621 19.9192 13.8959 19.2693 14.2557 18.5453C13.8588 18.2645 13.3745 18.0988 12.8513 18.0988C12.6608 18.0988 12.4757 18.1214 12.2978 18.1628C11.9207 17.3061 11.0648 16.7075 10.0687 16.7075C9.07268 16.7075 8.21668 17.3061 7.83968 18.1628C7.66174 18.1214 7.47662 18.0988 7.28618 18.0988C6.76299 18.0988 6.27868 18.2645 5.88174 18.5453C6.24143 19.2693 6.87524 19.9191 7.77943 20.4875Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSlovakia);
export default __webpack_public_path__ + "static/media/flag_slovakia.ccc5bd71d027ed257352cb56b4ab1f17.svg";
export { ForwardRef as ReactComponent };